import * as React from 'react';
import { render, hydrate } from 'react-dom';
import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { ErrorLogComponent } from '@cian/error-log-component';
import { getWS } from '../../app/ws';
import { IHeaderV1Schema } from '../../../shared/repositories/header/entities/response/HeaderV1Schema';

export async function initializeChatsCounter() {
  const chatsCounterElement = document.getElementById('header-menu-chats');
  const config = getConfig();
  const logger = getLogger();
  const baseUrl = `//${config.getStrict<string>('legacy.linksBaseUrl')}`;

  if (chatsCounterElement) {
    const { ChatsCounter } = await import('../../../shared/chats_counter');
    const chatNotificationContextValue = { httpApi: getHttpApi(), logger, socket: getWS() };

    if (config.get<boolean>('userIsAuthenticated')) {
      const { ChatsNotifications, ChatsNotificationsContext } = await import(
        '../../../shared/containers/ChatsNotifications'
      );

      render(
        <ErrorLogComponent logger={logger}>
          <ChatsNotificationsContext.Provider value={chatNotificationContextValue}>
            <ChatsNotifications>
              {({ notificationsCount }) => <ChatsCounter notificationsCount={notificationsCount} baseUrl={baseUrl} />}
            </ChatsNotifications>
          </ChatsNotificationsContext.Provider>
        </ErrorLogComponent>,
        chatsCounterElement,
      );
    } else {
      render(
        <ErrorLogComponent logger={logger}>
          <ChatsCounter notificationsCount={null} baseUrl={baseUrl} />
        </ErrorLogComponent>,
        chatsCounterElement,
      );
    }
  }
}

export async function initializeChatsNotificator() {
  const chatsNotificatorElement = document.getElementById('header-chats-icon');
  const config = getConfig();
  const logger = getLogger();
  const baseUrl = `//${config.getStrict<string>('legacy.linksBaseUrl')}`;
  const chatNotificationContextValue = { httpApi: getHttpApi(), logger, socket: getWS() };

  if (chatsNotificatorElement) {
    const { ChatsNotificator } = await import('../../../shared/chats_notificator');
    const { ChatsNotifications, ChatsNotificationsContext } = await import(
      '../../../shared/containers/ChatsNotifications'
    );

    render(
      <ErrorLogComponent logger={logger}>
        <ChatsNotificationsContext.Provider value={chatNotificationContextValue}>
          <ChatsNotifications>
            {({ notificationsCount }) => (
              <ChatsNotificator notificationsCount={notificationsCount} baseUrl={baseUrl} isAuthenticated={true} />
            )}
          </ChatsNotifications>
        </ChatsNotificationsContext.Provider>
      </ErrorLogComponent>,
      chatsNotificatorElement,
    );
  }
}

export async function initializeNewChatsNotificator(headerData: IHeaderV1Schema) {
  const chatsNotificatorElement = document.getElementById('header-chats-icon-new');
  const config = getConfig();
  const logger = getLogger();
  const baseUrl = `//${config.getStrict<string>('legacy.linksBaseUrl')}`;
  const chatNotificationContextValue = { httpApi: getHttpApi(), logger, socket: getWS() };

  if (chatsNotificatorElement) {
    const { NewChatsNotificator } = await import('../../../shared/components/GroupIcons/Chat');
    const { ChatsNotifications, ChatsNotificationsContext } = await import(
      '../../../shared/containers/ChatsNotifications'
    );

    hydrate(
      <ErrorLogComponent logger={logger}>
        <ChatsNotificationsContext.Provider value={chatNotificationContextValue}>
          <ChatsNotifications>
            {({ notificationsCount }) => (
              <NewChatsNotificator headerData={headerData} notificationsCount={notificationsCount} baseUrl={baseUrl} />
            )}
          </ChatsNotifications>
        </ChatsNotificationsContext.Provider>
      </ErrorLogComponent>,
      chatsNotificatorElement,
    );
  }
}
